import { InteractionRequiredAuthError, IPublicClientApplication } from '@azure/msal-browser';
import * as microsoftTeams from '@microsoft/teams-js';
import { TeamsState } from './store/TeamsState';

export const TokenHelper = {
    GetToken: async (msalInstance: IPublicClientApplication, teamsState: TeamsState | undefined): Promise<string> => {
        if (teamsState && teamsState.InTeams) {
            return await microsoftTeams.authentication.getAuthToken();
        } else if (msalInstance.getAllAccounts().length > 0) {
            const request = {
                scopes: ["openid"],
                //scopes: ["api://687c8a62-8d78-40a1-b3a7-9f2699a6247d/.default"],
                account: msalInstance.getAllAccounts()[0]
            };
            try {
                const response = await msalInstance.acquireTokenSilent(request);
                console.log("msal res", response);
                return response.idToken;
                //return response.accessToken;
            }
            catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    const response = await msalInstance.acquireTokenPopup(request);
                    return response.idToken;
                    //return response.accessToken;
                }
            }
        }
        throw "No valid token";
    },
    GetGraphToken: async (msalInstance: IPublicClientApplication, teamsState: TeamsState, SSO: string | null | undefined): Promise<string | null> => {
        if (teamsState.InTeams) {
            return SSO ? SSO : null;
        } else if (msalInstance.getAllAccounts().length > 0) {
            const request = {
                scopes: ["openid"],
                account: msalInstance.getAllAccounts()[0]
            };
            try {
                const response = await msalInstance.acquireTokenSilent(request);
                return response.accessToken;

            }
            catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    const response = await msalInstance.acquireTokenPopup(request);
                    return response.accessToken;
                }
            }
        }
        return null;
    }
};